var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.94 14.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-width: 1.25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.12,8.65c-.2.18-.47.29-.76.29s-.56-.11-.76-.29c-1.13,2.37-4.14,2.7-3.73,3.94.44,1.31,3.82,2.06,4.86,1.58,1.13-.52.57-4.28.46-5.52h-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.65,6.78c.18.2.29.47.29.76s-.11.56-.29.76c2.37,1.13,2.7,4.14,3.94,3.73,1.31-.44,2.06-3.82,1.58-4.86-.52-1.13-4.28-.57-5.52-.46v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.29,8.16c-.18-.2-.29-.47-.29-.76s.11-.56.29-.76c-2.37-1.13-2.7-4.14-3.94-3.73-1.31.44-2.06,3.82-1.58,4.86.52,1.13,4.28.57,5.52.46v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.76,6.29c.2-.18.47-.29.76-.29s.56.11.76.29c1.13-2.37,4.14-2.7,3.73-3.94-.44-1.31-3.82-2.06-4.86-1.58-1.13.52-.57,4.28-.46,5.52h.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.48,
    cy: 7.5,
    r: 1.47
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFan);
export default __webpack_public_path__ + "static/media/icon_fan.da81203bb26da4d70c13787156babf8e.svg";
export { ForwardRef as ReactComponent };